import { makeAutoObservable, runInAction } from 'mobx';
import createStoreContext from '../createStoreContext';
import {
  ActiveUserPingPayload,
  UserWithoutTokens,
} from 'src/types/activeUsers';
import { pollActiveUser, getActiveUsers } from 'src/services/activeUsers';
import {
  ACTIVE_USERS_POLL_INTERVAL_MS,
  ACTIVE_USERS_MAX_DISPLAY,
} from 'src/constants/activeUsers';

export const [ActiveUsersStoreProvider, useActiveUsersStore] =
  createStoreContext(
    class ActiveUsersStore {
      activeUsers: UserWithoutTokens[] = [];
      private intervalId: NodeJS.Timeout | null = null;

      constructor() {
        makeAutoObservable(this);
      }

      startPolling = (payload: ActiveUserPingPayload = {}): void => {
        this.stopPolling();
        this.poll(payload);
        this.intervalId = setInterval(
          () => this.poll(payload),
          ACTIVE_USERS_POLL_INTERVAL_MS,
        );
      };

      stopPolling = (): void => {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      };

      private poll = async (payload: ActiveUserPingPayload): Promise<void> => {
        try {
          await pollActiveUser(payload);
          const { success, content } = await getActiveUsers();

          if (success && content) {
            runInAction(() => {
              this.activeUsers = content.slice(0, ACTIVE_USERS_MAX_DISPLAY);
            });
          }
        } catch {
          // ignore errors to avoid noisy logs
        }
      };
    },
  );

export type ActiveUsersStore = ReturnType<typeof useActiveUsersStore>;
